import 'reflect-metadata';
import { jsonMember } from 'typedjson';
import { DataSerializerUtils } from '../DataSerializerUtils';
/**
 * @param {SerializableMemberOptions} [options] Member options
 * @returns {PropertyDecorator} Property decorator
 */
export function SerializableMember(options) {
  return (target, propertyKey) => {
    const finalOptions = DataSerializerUtils.mergeMemberOptions(target, propertyKey, options);
    jsonMember(finalOptions)(target, propertyKey);
    DataSerializerUtils.updateMemberOptions(target, propertyKey, finalOptions);
  };
}